import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import { environment } from '@environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  /**
   * If the user is logged in and the request is to the API, then add the JWT to the Authorization
   * header
   * @param request - HttpRequest<unknown> - The request object that is being intercepted.
   * @param {HttpHandler} next - The next interceptor in the chain.
   * @returns The next.handle(request) is being returned.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isLoggedIn = this.authService.isLoggedIn();
    const isApiUrl = request.url.startsWith(environment.apiUrl);

    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.getUserToken()}`,
        },
      });
    }

    return next.handle(request);
  }
}
